export function normaliseItemCode(code) {
  return code.toLowerCase().trim();
}
